module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/advisor_tiktok_desktop_08@2x-0b37d4b336bca23d2348838a36ea671a.jpg";